import React from "react";
import "./soon.scss";
import Comingsoon from "../../Media/Maple_Desktop.webp";
import Soon from "../../Media/Maple_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6287874691787&text=Halo%20Heldy,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Summarecon%20Bogor%20(Maple%20Golf%20Residence)%20https://marketingrumahbogor.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="Maple" className="container-soon">
      <div className="judul">
        <h1>New Launching Summarecon Bogor</h1>
        <h2>Maple Golf Residence</h2>
      </div>
      <div className="maps-lokasi">
        <img className="img-lokasi-dekstop" src={Comingsoon} alt="maps" />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <p className="comingsoon-disclaimer">
        Informasi properti harga, spesifikasi, dan ketersediaan unit dapat
        berubah sewaktu-waktu, silahkan hubungi kamu untuk informasi terbaru
      </p>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
